import React, { useContext } from "react";
import { MdCheckCircle, MdClear } from "react-icons/md";
import AuthContext from "../context/AuthContext";

function Success({ message, title = "Error", close }) {
  const { setLoginError } = useContext(AuthContext);
  return (
    <div className="absolute w-screen top-5 flex justify-center z-50">
      <div className="bg-green-100 flex items-center justify-between p-3 w-96 rounded-xl border-2 border-green-400">
        <div className="flex items-center gap-2 ">
          <div className="bg-green-600 p-1.5 rounded-full mr-1">
            <MdCheckCircle className="text-2xl text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700">{title}</p>
            <p className="text-xs text-gray-700">{message}</p>
          </div>
        </div>
        <MdClear
          onClick={() => {
            close ? close() : setLoginError(false);
          }}
          className="text-2xl text-green-600 hover:text-green-900"
        />
      </div>
    </div>
  );
}

export default Success;
